import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { CLINICAL_REQUESTS_REPOSITORY } from '../domain/repositories/clinical-requests.repository';
import { ClinicalRequestsRemoteDatasource } from './datasources/remote/clinical-requests.remote-datasource';
import { ClinicalRequestMapper } from './mappers/clinical-request.mapper';
import { ClinicalRequestsRepositoryImpl } from './repositories/clinical-requests.repository.impl';

export function provideClinicalRequestsData(): EnvironmentProviders {
  return makeEnvironmentProviders([
    ClinicalRequestsRemoteDatasource,
    ClinicalRequestMapper,
    { provide: CLINICAL_REQUESTS_REPOSITORY, useClass: ClinicalRequestsRepositoryImpl },
  ]);
}
